














































import { defineComponent } from "@vue/composition-api";
import { Expandable, AssociationSelect, TextField } from "@/components";
import { BlockLabel } from "@/models/BlockLabel";
import { Federation } from "@/models/Federation";

export default defineComponent({
  name: "DiscountByPercentage",
  components: {
    Expandable,
    AssociationSelect,
    TextField,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      displayName: BlockLabel.DiscountByPercentage,
      discount: 0,
      associationNhoNumber: 0,
      associationName: "",
      description: "",
    };
  },
  computed: {
    associations(): Array<Federation> {
      return this.$store.getters.associations;
    },
  },
  mounted() {
    if (this.data) {
      this.discount = this.data.discount;
      this.associationNhoNumber = this.data.associationNhoNumber;
      this.associationName = this.data.associationName;
      this.description = this.data.description;
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.associationNhoNumber = this.getNumberFromName(
        this.associationName
      );
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        discount: this.discount,
        associationNhoNumber: this.associationNhoNumber,
        associationName: this.associationName,
        description: this.description,
      });
    },
    getNumberFromName(assocationName: string): number {
      const item = this.associations?.find(
        (org: Federation) => org.name === assocationName
      );
      return item?.nhoNumber ?? 0;
    },
    getAssociationText() {
      if (this.associationNhoNumber > 0)
        return `for medlemmer av ${this.associationName}`;
      return "";
    },
  },
});
